import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { Dealer } from 'src/app/models/entities/dealer';
import { VLogoCustomer } from 'src/app/models/entities/v-logo-customer';
import { DealerService } from 'src/app/services/dealer.service';
import { LogoService } from 'src/app/services/logo.service';
import { NbsUserService } from 'src/app/services/nbs-user.service';

@Component({
  selector: 'app-dealer-add',
  templateUrl: './dealer-add.component.html',
  styleUrls: ['./dealer-add.component.css']
})
export class DealerAddComponent implements OnInit {

  destroy$ = new Subject<void>();
  customers$: Observable<VLogoCustomer[]>;
  form: FormGroup;
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private toastrService: ToastrService,
    private dealerService: DealerService,
    private userService: NbsUserService,
    private logoService: LogoService
  ) { }

  ngOnInit(): void {
    this.createForm();
    this.customers$ = this.logoService.getCustomers().pipe(map(result => result.data));
  }

  createForm() {
    this.form = this.formBuilder.group({
      id: 0,
      dealerName: ["", Validators.required],
      customerId: ["", Validators.required],
      isActive: true
    })
  }

  add() {
    if (this.form.valid) {
      const dealer: Dealer = this.form.getRawValue();
      dealer.userId = this.userService.getUserId();
      this.dealerService.add(dealer).pipe(takeUntil(this.destroy$)).subscribe(
        data => {
          this.toastrService.success(data.message, "Başarılı");
          this.router.navigateByUrl('/dealer');
        },
        er => {
          this.toastrService.error(er.error.message, "Hata!");
        }
      );
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }

}
